import { Interface } from "readline"
import { Body, BodyColor, BodyType, Button, ButtonSize, ButtonTheme, ButtonVariant, Heading, TypographyColor, TypographyType } from "../../ui-elements"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { dropdownList, geoState, selectedGeoNameState } from "../../states";
import { useNavigate } from "react-router-dom";
import { createSearchParams } from "../../helpers";
import { RouteConstants } from "../../constants";
import { poiVisibleState } from "../../states/DashboardState";
import { useMemo } from "react";

interface ZeroPoIProps {

}
export const ZeroPoI = () => {
    const selectedGeoName = useRecoilValue(selectedGeoNameState);
    const [selectedGeo, setSelectedGeo] = useRecoilState(geoState);
    const geoDropdownList = useRecoilValue(dropdownList);
    const navigate = useNavigate();
    const [poiVisible, setPoiVisible] = useRecoilState(poiVisibleState);

    // Calculate the parent geo name based on current level
    const parentGeoName = useMemo(() => {
        if (selectedGeo.village) {
            // If at village level, return sub_district or pincode name
            const subDistrictGeoId = (selectedGeo.sub_district);
            const found = geoDropdownList.sub_districts?.dropDownData?.find(
                (item: any) => item.geoId === subDistrictGeoId
            );
            return found?.geoName || 'Sub-District';
        } else if (selectedGeo.sub_district) {
            // If at sub_district/pincode level, return district name
            const districtGeoId = (selectedGeo.district);
            const found = geoDropdownList.districts?.dropDownData?.find(
                (item: any) => item.geoId === districtGeoId
            );
            return found?.geoName || 'District';
        } else if (selectedGeo.district) {
            // If at district level, return state name
            const stateGeoId = (selectedGeo.state);
            const found = geoDropdownList.states?.dropDownData?.find(
                (item: any) => item.geoId === stateGeoId
            );
            return found?.geoName || 'State';
        } else if (selectedGeo.state) {
            // If at state level, return India
            return 'India';
        }
        return 'India';
    }, [selectedGeo, geoDropdownList]);

    const handleReturnToPreviousPlace = () => {
        // Determine the current level and go back one level
        let updatedGeo = { ...selectedGeo };

        if (selectedGeo.village) {
            // Go back to sub_district level
            updatedGeo = {
                ...selectedGeo,
                village: '',
            };
        } else if (selectedGeo.sub_district) {
            // Go back to district level
            updatedGeo = {
                ...selectedGeo,
                sub_district: '',
            };
        } else if (selectedGeo.district) {
            // Go back to state level
            updatedGeo = {
                ...selectedGeo,
                district: '',
            };
        } else if (selectedGeo.state) {
            // Go back to country level
            updatedGeo = {
                ...selectedGeo,
                state: '',
            };
        }

        // Update the geo state
        setSelectedGeo(updatedGeo);

        // Navigate to dashboard with updated params
        setTimeout(() => {
            const newSearchParams = createSearchParams(updatedGeo);
            navigate(RouteConstants.dashboard + "?" + newSearchParams);
        }, 0);
    };

    return (
        <div className="h-100 d-flex align-items-center flex-column padding-left-right-27 padding-top-5-712 padding-bottom-15-708 gap-2">
            <Heading
                title='There are 0 PoIs in this region.'
                type={TypographyType.h3}
                colour={TypographyColor.primary}
                classname='fs-23 line-height-120 ff-poppins-semibold'
            />
            <Body
                type={BodyType.p1}
                color={BodyColor.primary}
                classname='line-height-120'
            >
                We could not find any PoIs in this area. Any PoIs if found in the future will be updated here.
            </Body>

            <hr className="w-100 margin-top-bottom-3-264"></hr>
            <Button
                theme={ButtonTheme.primary}
                size={ButtonSize.large}
                variant={ButtonVariant.transparent}
                type='button'
                onClick={handleReturnToPreviousPlace}
                classname='height-3rem'
            >
                <u>{`Return to ${parentGeoName}`}</u>
            </Button>
            <div className=" h-75 w-100 zeroPoIBackgroundImage mt-2 d-flex align-items-end  padding-bottom-5 justify-content-center">
                {/* <Body
                    type={BodyType.p3}
                    color={BodyColor.primary}
                    classname='line-height-120'
                >
                    {`Last updated on ${poiVisible.poiUpdatedDate}`}
                </Body> */}
            </div>
        </div>
    )
}